import type { Language } from '../components/Scenes.js';

/** Maps URL language codes to the design-system Language names */
export const LANG_CODE_TO_NAME: Record<string, Language> = {
  es: 'Spanish',
  pt: 'Portuguese',
  fi: 'Finnish',
};

/** Maps URL language codes to display labels */
export const LANG_CODE_TO_LABEL: Record<string, string> = {
  es: 'Español',
  pt: 'Português',
  fi: 'Suomi',
};

export function langCodeToName(code: string): Language {
  return LANG_CODE_TO_NAME[code] ?? 'Spanish';
}

/** Apply the correct data-lang attribute to <html> for CSS variable theming */
export function applyTheme(language: Language) {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-lang', language);
  }
}
